const applicationTab =  {
    LOAD_APPLICATION_TAB: "LOAD_APPLICATION_TAB",
    LOADED_APPLICATION_TAB: "LOADED_APPLICATION_TAB",
    ERROR_LOADING_APPLICATION_TAB: "ERROR_LOADING_APPLICATION_TAB"
};

export default applicationTab;